/**
 * Asserts that the passed `value` is neither `undefined` nor `null`.
 * @param value that should be checked.
 * @param msg Optional message that will be used in the thrown `Error`, instead of the default one.
 * @throws An error when the passed `value` is either `undefined` or `null`.
 */
export function assertNotNullish(value: any, msg?: string): asserts value {
    if (value === undefined || value === null) {
        throw new Error(msg ?? 'Passed value was either null or undefined.')
    }
}
